import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import type { BulkResolutionResult } from '../../types';

export default function useConfirmMatches() {
  const queryClient = useQueryClient();

  return useMutation<{ data: BulkResolutionResult }, Error, string[]>({
    mutationFn: (suggestionIds: string[]) =>
      api.post<BulkResolutionResult>('connected-assets/matches/confirm', { suggestionIds }),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['connected-assets'] });
    },
  });
}
